<template>
  <div class="content">
    <NavbarShowcase />
    <v-main>
      <v-container fluid>
        <div class="showcase-content">
          <div class="sc-aside">
            <v-card title="Convocatorias Públicas">
              <v-card-text>
                <div class="text-overline font-weight-light">Convocatoria</div>
                <div>{{ convocatory.name }}</div>
                <div>A continuación, podrás encontrar las rutas que hacen parte de esta convocatoria.</div>
                <div class="text-overline font-weight-light mt-3">Detalles</div>
                <div>
                  Te invitamos a
                  inscribirte en la ruta de tu interés antes del {{ filter.formatDate(convocatory.date_inscription, 1)
                  }}.
                  Este proceso tendrá una duración de {{ filter.differentDate(convocatory.date_begin,
                  convocatory.date_end) }} Semana (s), iniciando el {{ filter.formatDate(convocatory.date_begin, 1) }}
                  y finalizando el {{ filter.formatDate(convocatory.date_end, 1) }}.
                </div>
                <div class="text-overline font-weight-light mt-3">Instituciones</div>
                <div>
                  <div v-if="institutions.length > 0">
                    Esta convocatoria está dirigita para las instituciones educativas:
                    <div v-for="(item, index) in institutions" :key="index">
                      {{ item.institucion }}
                    </div>
                  </div>
                  <div v-else>
                    Todas las instituciones y organizaciones.
                  </div>
                </div>
                <div class="text-overline font-weight-light mt-3">Aliados</div>
                <div>
                  <div v-if="allie">
                    <div class="allies">
                      <v-sheet class="allie-cover d-flex align-center justify-center" v-for="(item, index) in allie"
                        :key="index">
                        <v-img :src="item.cover" max-width="150" />
                      </v-sheet>
                    </div>
                  </div>
                  <div v-else>
                    Ningún aliado asignado.
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
          <div class="sc-section">
            <v-card class="mb-3" v-for="(item, index) in routes" :key="index" :value="index">
              <v-card-title>
                {{ item.oferta }}
              </v-card-title>
              <v-card-text>
                <div class="sc-info mx-5 py-5">
                  <div class="sc-picture">
                    <v-img cover rounded="lg" :src="item.cover"></v-img>
                    <div :style="'background-size: cover; background-image: url({{ item.cover }});'"></div>
                  </div>
                  <div class="sc-data d-flex flex-column">
                    <div class="text-overline font-weight-light text-uppercase mt-3">Objetivo</div>
                    <div v-html="item.ofertadescripcion"></div>
                    <div class="text-overline font-weight-light text-uppercase mt-3">Descripción</div>
                    <div v-html="item.descripcion"></div>
                    <div class="text-overline font-weight-light text-uppercase mt-3">Competencias</div>
                    <div v-html="item.competencias"></div>
                    <div class="text-overline font-weight-light text-uppercase mt-3">Detalles</div>
                    <div>
                      <v-list lines="one" density="compact">
                        <v-list-item>
                          <template v-slot:prepend>
                            <v-icon icon="mdi-clock"></v-icon>
                          </template>
                          <v-list-item-title class="text-caption">
                            {{ item.horas_certificadas }} hrs. semanales
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <template v-slot:prepend>
                            <v-icon>mdi-white-balance-sunny</v-icon>
                          </template>
                          <v-list-item-title class="text-caption">
                            Jornada {{ item.jornadas }}
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item>
                          <template v-slot:prepend>
                            <v-icon icon="mdi-laptop"></v-icon>
                          </template>
                          <v-list-item-title class="text-caption">
                            Modalidad {{ item.modalidad }}
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </div>
                    <div class="mb-auto"></div>
                    <div>
                      <v-btn variant="flat" size="large" color="warning" prepend-icon="mdi-table-plus"
                        :disabled="showcase" style="color: white !important;" @click="inscription(item.id)">
                        Inscribirme
                      </v-btn>
                    </div>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </div>
        </div>
      </v-container>
    </v-main>

    <!-- Process -->
    <v-dialog v-model="process" max-width="320" persistent>
      <v-list class="py-2" color="primary" elevation="12" rounded="lg">
        <v-list-item prepend-icon="mdi-clock" title="Espera...">
          <template v-slot:prepend>
            <div class="pe-4">
              <v-icon color="primary" size="x-large"></v-icon>
            </div>
          </template>
          <template v-slot:append>
            <v-progress-circular color="primary" indeterminate="disable-shrink" size="16" width="2" />
          </template>
        </v-list-item>
      </v-list>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="showcase" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="error" icon="mdi-calendar-remove" size="112" />
        <h2 class="text-h5 mb-3">Convocatoria Cerrada</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          Desafortunadamente el tiempo de inscripción se ha terminado, pero te invitamos a ingresar a nuestra página web
          para que conozcas más de nuestra labor.
        </p>
        <div class="text-center">
          <v-btn class="text-none" color="error" variant="plain" prepend-icon="mdi-open-in-new"
            text="www.unitedwaycolombia.org" @click="openlink('https://unitedwaycolombia.org')" />
        </div>
      </v-sheet>
    </v-dialog>

    <!-- error -->
    <v-dialog v-model="error.state" persistent max-width="500">
      <v-sheet class="pa-4 text-center mx-auto" elevation="12" max-width="600" rounded="lg" width="100%">
        <v-icon class="mb-5" color="warning" icon="mdi-alert-outline" size="112" />
        <h2 class="text-h5 mb-6">Registro Eventos</h2>
        <p class="mb-4 text-medium-emphasis text-body-2">
          {{ error.text }}
        </p>
      </v-sheet>
    </v-dialog>
  </div>
</template>
<script setup>
import NavbarShowcase from '../components/navbar/NavbarShowcase';
import axios from 'axios';
import Params from '@/models/params';
import Filters from '@/models/filters';
import Convocatory from '@/models/convocatory';
import { ref, reactive, onMounted } from "vue";
import { useRoute, useRouter } from 'vue-router';
import moment from 'moment';

const length = ref(null)
const showcase = ref(false)
const process = ref(true)
const params = ref(new Params)
const filter = ref(new Filters)
const convocatory = reactive(new Convocatory)
const routes = ref([])
const allie = ref([])
const institutions = ref([])
const route = useRoute();
const router = useRouter();
const code = route.params.code;
const error = reactive({
  state: null,
  text: null
})

async function load() {
  const frm = new FormData;
  frm.append("action", "vitrina");
  frm.append("value", code);
  const result = await eject(frm);
  process.value = false;

  if (result.state) {
    if (result.datos.length == 0) {
      error.text = "Esta convocatoria aún no tiene rutas de formación asignadas, por favor intenta realizar tu inscripción más tarde."
      error.state = true;
      return;
    }
    length.value = result.datos.length;
    routes.value = result.datos;
    convocatory.name = result.datos[0].convocatoria
    convocatory.program = result.datos[0].programa
    convocatory.date_begin = result.datos[0].desde
    convocatory.date_end = result.datos[0].hasta
    convocatory.date_inscription = result.datos[0].inscripcion
    convocatory.state = result.datos[0].state
    institutions.value = result.institutions
    showcase.value = (!convocatory.state || moment(convocatory.date_end).diff(moment(), 'days') > 0) ? false : true;
    images();
    //auto();
  }

}

async function allies() {
  const f = new FormData;
  f.append("action", "aliados");
  f.append("value", code);
  const result = await eject(f);
  if (result.state) {
    allie.value = result.datos;
    await Promise.all(
      allie.value.map(async (item) => {
        try {
          const f = new FormData;
          f.append("action", "logo");
          f.append("value", item.logo);
          const imageResponse = await axios.post(params.value.controller + 'vitrina.php', f, {
            responseType: 'blob'
          });
          if(imageResponse.data.type.startsWith('image/')){
            item.cover = URL.createObjectURL(imageResponse.data);
          } else{
            item.cover = require('@/assets/images/logo.png');
          }
        } catch (error) {
          console.log('Error al cargar la imagen.');
          item.image = require('@/assets/images/logo.png');
        }
      })
    );
  }
}

async function images() {
  await Promise.all(
    routes.value.map(async (item) => {
      try {
        const f = new FormData;
        f.append("action", "cover");
        f.append("value", item.imagen);
        const imageResponse = await axios.post(params.value.controller + 'vitrina.php', f, {
          responseType: 'blob'
        });
        if(!imageResponse){
          item.cover = require('@/assets/images/image_default.png');
        } else {
          item.cover = URL.createObjectURL(imageResponse.data);
        }
      } catch (error) {
        console.log('Error al cargar la imagen.');
        item.cover = require('@/assets/images/image_default.png');
      }
    })
  );

}

function inscription(route) {
  router.push({ name: 'convocatoryregister', params: { code: code, route: route } });
}

function openlink(link) {
  window.open(link)
}

/*function auto(){
  interval.value = setInterval(()=>{
    onboarding.value = onboarding.value >= 2 ? 1 : onboarding.value = onboarding.value + 1;
  },5000);
}*/

function eject(f) {
  return new Promise((resolve) => {
    axios.post(params.value.controller + 'vitrina.php', f)
      .then(res => {
        resolve(res.data)
      })
      .catch(() => {
        resolve(null)
      })
  })
}

onMounted(() => {
  load();
  allies();
})
</script>